// === 홈 대시보드 스토어 import ===
import { useKSK1030_R01Store } from "src/containers/mes/KSK/KSK1030_R01/Store_KSK1030_R01";
import { useKSK1070_R01Store } from "src/containers/mes/KSK/KSK1070_R01/Store_KSK1070_R01";
import { useKSK1080_R01Store } from "src/containers/mes/KSK/KSK1080_R01/Store_KSK1080_R01";
import { useKSK1081_R01Store } from "src/containers/mes/KSK/KSK1081_R01/Store_KSK1081_R01";
import { useKSK1090_R01Store } from "src/containers/mes/KSK/KSK1090_R01/Store_KSK1090_R01";
import { useKSK1110_R01Store } from "src/containers/mes/KSK/KSK1110_R01/Store_KSK1110_R01";
import { useKSK2010_R01Store } from "src/containers/mes/KSK/KSK2010_R01/Store_KSK2010_R01";
import { useKSK2011_R01Store } from "src/containers/mes/KSK/KSK2011_R01/Store_KSK2011_R01";
import { useKSK2020_R01Store } from "src/containers/mes/KSK/KSK2020_R01/Store_KSK2020_R01";
import { useKSK2021_R01Store } from "src/containers/mes/KSK/KSK2021_R01/Store_KSK2021_R01";
import { useKSK2022_R01Store } from "src/containers/mes/KSK/KSK2022_R01/Store_KSK2022_R01";
import { useKSK2030_R01Store } from "src/containers/mes/KSK/KSK2030_R01/Store_KSK2030_R01";
import { useKSK2070_R01Store } from "src/containers/mes/KSK/KSK2070_R01/Store_KSK2070_R01";
import { useKSK2080_R01Store } from "src/containers/mes/KSK/KSK2080_R01/Store_KSK2080_R01";
import { useKSK2090_R01Store } from "src/containers/mes/KSK/KSK2090_R01/Store_KSK2090_R01";
import { useKSK2101_R01Store } from "src/containers/mes/KSK/KSK2101_R01/Store_KSK2101_R01";
import { useKSK2110_R01Store } from "src/containers/mes/KSK/KSK2110_R01/Store_KSK2110_R01";
import { useKSK2120_R01Store } from "src/containers/mes/KSK/KSK2120_R01/Store_KSK2120_R01";

export const resetAllStores = () => {
  try {
    console.log('🔄 모든 MES 모듈 스토어 초기화 시작...');

	// === 모든 스토어 초기화 (tabInitializer 재사용) ===
    initializeAllStores();

    // === 로컬스토리지에서 그리드 컬럼 상태 제거 ===
    const keysToRemove = [
		'KSK1030_R01-info-split-height',
		'KSK1030_R01-detail-lot-split-width',
		'KSK1030_R01-detail-grid-column-state',
		'KSK1030_R01-lot-grid-column-state',
		'KSK1070_R01-info-split-height',
		'KSK1070_R01-detail2-split-height',
		'KSK1070_R01-detail-grid-column-state',
		'KSK1070_R01-lot-grid-column-state',
		'KSK1080_R01-grid-column-state',
		'KSK1081_R01-grid-column-state',
		'KSK1090_R01-grid-column-state',
		'KSK1110_R01-target-bottom-split-height',
		'KSK1110_R01-info-detail-split-width',
		'KSK1110_R01-table-info-split-height',
		'KSK1110_R01-info-detail-split-height',
		'KSK1110_R01-target-grid-column-state',
		'KSK1110_R01-detail-grid-column-state',
		'KSK2010_R01-grid-column-state',
		'KSK2011_R01-grid-column-state',
		'KSK2011_R01-detail-grid-column-state',
		'KSK2011_R01-modal-split-width',
		'KSK2020_R01-grid-column-state',
		'KSK2020_R01-lot-grid-column-state',
		'KSK2020_R01-detail-grid-column-state',
		'KSK2020_R01-inspect-grid-column-state',
		'KSK2020_R01-downtime-grid-column-state',
		'KSK2021_R01-grid-column-state',
		'KSK2021_R01-lot-grid-column-state',
		'KSK2021_R01-detail-grid-column-state',
		'KSK2021_R01-inspect-grid-column-state',
		'KSK2021_R01-downtime-grid-column-state',
		'KSK2022_R01-grid-column-state',
		'KSK2022_R01-lot-grid-column-state',
		'KSK2022_R01-detail-grid-column-state',
		'KSK2022_R01-inspect-grid-column-state',
		'KSK2022_R01-downtime-grid-column-state',
		'KSK2030_R01-grid-column-state',
		'KSK2070_R01-grid-column-state',
		'KSK2080_R01-grid-column-state',
		'KSK2090_R01-grid-column-state',
		'KSK2090_R01-detail-grid-column-state',
		'KSK2101_R01-grid-column-state',
		'KSK2120_R01-grid-column-state',
		'KSK2110_R01-grid-column-state',
		'KSK2110_R01-lot-grid-column-state',
		'KSK2110_R01-detail-grid-column-state',
		'KSK2110_R01-inspect-grid-column-state',
		'KSK2110_R01-downtime-grid-column-state',
    ];
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    
    console.log('✅ 모든 MES 모듈 스토어가 성공적으로 초기화되었습니다.');
  } catch (error) {
    console.error('❌ 스토어 초기화 중 오류 발생:', error);
  }
}; 

// 스토어 초기화 맵
const initMap: Record<string, () => void> = {
	'KSK1030_R01': () => useKSK1030_R01Store.getState().initData(),
	'KSK1070_R01': () => useKSK1070_R01Store.getState().initData(),
	'KSK1080_R01': () => useKSK1080_R01Store.getState().initData(),
	'KSK1081_R01': () => useKSK1081_R01Store.getState().initData(),
	'KSK1090_R01': () => useKSK1090_R01Store.getState().initData(),
	'KSK1110_R01': () => useKSK1110_R01Store.getState().initData(),
	'KSK2010_R01': () => useKSK2010_R01Store.getState().initData(),
	'KSK2011_R01': () => useKSK2011_R01Store.getState().initData(),
	'KSK2020_R01': () => useKSK2020_R01Store.getState().initData(),
	'KSK2021_R01': () => useKSK2021_R01Store.getState().initData(),
	'KSK2022_R01': () => useKSK2022_R01Store.getState().initData(),
	'KSK2030_R01': () => useKSK2030_R01Store.getState().initData(),
	'KSK2070_R01': () => useKSK2070_R01Store.getState().initData(),
	'KSK2080_R01': () => useKSK2080_R01Store.getState().initData(),
	'KSK2090_R01': () => useKSK2090_R01Store.getState().initData(),
	'KSK2101_R01': () => useKSK2101_R01Store.getState().initData(),
	'KSK2110_R01': () => useKSK2110_R01Store.getState().initData(),
	'KSK2120_R01': () => useKSK2120_R01Store.getState().initData(),
};


/**
 * 탭 key에 따라 해당 화면의 스토어를 초기화하는 함수
 * @param key 탭의 고유 키 (예: 'MST1010_R01')
 * @description
 * - 탭을 닫을 때 해당 화면의 상태를 초기화하여 메모리 누수 방지
 * - useUiuxStore의 closeAllTabs, closeOtherTabs, closeRightTabs에서 사용
 * - tabUtils의 handleExitClick에서도 사용
 */
export const initializeTabStore = (key: string): void => {
	// 해당 key에 매핑된 초기화 함수가 있으면 실행
	const initFn = initMap[key];
	if (initFn) {
		try {
			initFn();
		} catch (error) {
			console.error(`[storeInitializer] ${key} 스토어 초기화 중 오류 발생:`, error);
		}
	}
};

/**
 * 등록된 모든 스토어 key 목록을 반환
 * @returns 모든 스토어 key 배열
 */
export const getAllStoreKeys = (): string[] => {
	return Object.keys(initMap);
};

/**
 * 모든 스토어를 초기화하는 함수 (로그아웃 시 사용)
 * @description
 * - resetAllStores에서 사용
 * - 등록된 모든 스토어의 initData()를 호출
 */
export const initializeAllStores = (): void => {
	const allKeys = getAllStoreKeys();
	allKeys.forEach(key => {
		initializeTabStore(key);
	});
};
